import type { VehicleTemplateType } from '../enums/VehicleTemplateType'

export class CreateUpdateVehicleTemplateEntity {
  name?: string
  type?: VehicleTemplateType
  maxConcurrentShipment?: number
  canHandleSensitiveOrders?: boolean
  canHandleExpensiveOrders?: boolean
}
